// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-index {
  margin-block: 8px;
  width: 100%;
  cursor: pointer;
  pointer-events: all;
  background-color: var(--theme-bg);
  border-color: var(--theme-border-color);
}
.search-index.ant-card:hover {
  background-color: var(--theme-primary);
  border-color: var(--theme-primary);
}
.search-index.ant-card:hover .ant-typography {
  color: #FFFFFF;
}
.search-index.ant-card:hover .ant-typography span > mark {
  color: #FFFFFF !important;
}
.search-index.ant-card:hover svg {
  color: #FFFFFF !important;
}
.search-index.ant-card.ant-card-type-inner .ant-card-body {
  padding-block: 8px;
  padding-inline: 12px;
}
.search-index.ant-card .ant-typography {
  margin: 0;
  color: var(--theme-text-color);
  display: block;
}
/* Phones: a compact row, the same height whatever the name, that reads as a button — filled like
   the map buttons, lifted by a soft shadow, and pressed in when tapped. */
@media screen and (max-width: 800px) {
  .search-index {
    border-color: transparent;
    border-radius: 10px;
    background-color: var(--theme-button-bg);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.14);
    transition: transform 0.1s ease, background-color 0.1s ease;
    -webkit-tap-highlight-color: transparent;
    user-select: none;
    /* The fill matches the drawer in dark mode, so the edge has to come from a border there. */
  }
  .search-index.ant-card {
    /* A tap leaves :hover applied on touch screens, which would keep the row painted blue. */
    /* Two lines at most, and the row's min-height (IndexCard) always leaves room for both. */
  }
  .search-index.ant-card:hover {
    background-color: var(--theme-button-bg);
    border-color: transparent;
  }
  .search-index.ant-card:hover .ant-typography {
    color: var(--theme-text-color);
  }
  .search-index.ant-card:hover .ant-typography span > mark {
    color: var(--theme-primary) !important;
  }
  .search-index.ant-card:active {
    background-color: var(--theme-button-bg-hover);
    transform: scale(0.98);
  }
  .search-index.ant-card .ant-typography {
    font-size: 13px;
    line-height: 18px;
  }
  .search-index.ant-card .title {
    font-size: 15px;
    line-height: 20px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
}
@media screen and (max-width: 800px) and (prefers-color-scheme: dark) {
  .search-index {
    border-color: var(--theme-border-color);
  }
}
@media screen and (max-width: 800px) and (prefers-color-scheme: dark) {
  .search-index.ant-card:hover {
    border-color: var(--theme-border-color);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/IndexCard/index.less"],"names":[],"mappings":"AAOA;EACI,iBAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,iCAAA;EACA,uCAAA;AANJ;AAUQ;EACI,sCAAA;EACA,kCAAA;AARZ;AAMQ;EAKQ,cAAA;AARhB;AAGQ;EAQY,yBAAA;AARpB;AAAQ;EAaQ,yBAAA;AAVhB;AAcQ;EAEQ,kBAAA;EACA,oBAAA;AAbhB;AATI;EA2BQ,SAAA;EACA,8BAAA;EACA,cAAA;AAfZ;AACA;0EAC0E;AAoB1E;EACI;IACI,yBAAA;IACA,mBAAA;IACA,wCAAA;IACA,yCAAA;IACA,2DAAA;IACA,wCAAA;IACA,iBAAA;IAlBJ,2FAA2F;EAC7F;EAwBM;IAtBJ,yFAAyF;IACzF,yFAAyF;EAC3F;EAuBU;IACI,wCAAA;IACA,yBAAA;EArBd;EAmBU;IASQ,8BAAA;EAzBlB;EAgBU;IAYY,sCAAA;EAzBtB;EA8BU;IACI,8CAAA;IACA,sBAAA;EA5Bd;EAMM;IA0BQ,eAAA;IACA,iBAAA;EA7Bd;EAEM;IAgCQ,eAAA;IACA,iBAAA;IACA,oBAAA;IACA,4BAAA;IACA,qBAAA;IACA,gBAAA;EA/Bd;AACF;AAXQ;EAAA;IACI,uCAAA;EAcV;AACF;AALgB;EAAA;IACI,uCAAA;EAQlB;AACF","sourcesContent":["@theme-primary: var(--theme-primary);\n@theme-bg: var(--theme-bg);\n@theme-button-bg: var(--theme-button-bg);\n@theme-button-bg-hover: var(--theme-button-bg-hover);\n@theme-text-color: var(--theme-text-color);\n@theme-border-color: var(--theme-border-color);\n\n.search-index {\n    margin-block: 8px;\n    width: 100%;\n    cursor: pointer;\n    pointer-events: all;\n    background-color: @theme-bg;\n    border-color: @theme-border-color;\n\n    &.ant-card {\n\n        &:hover {\n            background-color: @theme-primary;\n            border-color: @theme-primary;\n\n            .ant-typography {\n                color: #FFFFFF;\n\n                span>mark {\n                    color: #FFFFFF !important;\n                }\n            }\n\n            svg {\n                color: #FFFFFF !important;\n            }\n        }\n\n        &.ant-card-type-inner {\n            .ant-card-body {\n                padding-block: 8px;\n                padding-inline: 12px;\n            }\n        }\n\n        .ant-typography {\n            margin: 0;\n            color: @theme-text-color;\n            display: block;\n        }\n    }\n}\n\n/* Phones: a compact row, the same height whatever the name, that reads as a button — filled like\n   the map buttons, lifted by a soft shadow, and pressed in when tapped. */\n@media screen and (max-width: 800px) {\n    .search-index {\n        border-color: transparent;\n        border-radius: 10px;\n        background-color: @theme-button-bg;\n        box-shadow: 0 1px 3px rgba(0, 0, 0, .14);\n        transition: transform .1s ease, background-color .1s ease;\n        -webkit-tap-highlight-color: transparent;\n        user-select: none;\n\n        /* The fill matches the drawer in dark mode, so the edge has to come from a border there. */\n        @media (prefers-color-scheme: dark) {\n            border-color: @theme-border-color;\n        }\n\n        &.ant-card {\n\n            /* A tap leaves :hover applied on touch screens, which would keep the row painted blue. */\n            &:hover {\n                background-color: @theme-button-bg;\n                border-color: transparent;\n\n                @media (prefers-color-scheme: dark) {\n                    border-color: @theme-border-color;\n                }\n\n                .ant-typography {\n                    color: @theme-text-color;\n\n                    span>mark {\n                        color: @theme-primary !important;\n                    }\n                }\n            }\n\n            &:active {\n                background-color: @theme-button-bg-hover;\n                transform: scale(.98);\n            }\n\n            .ant-typography {\n                font-size: 13px;\n                line-height: 18px;\n            }\n\n            /* Two lines at most, and the row's min-height (IndexCard) always leaves room for both. */\n            .title {\n                font-size: 15px;\n                line-height: 20px;\n                display: -webkit-box;\n                -webkit-box-orient: vertical;\n                -webkit-line-clamp: 2;\n                overflow: hidden;\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
